export default __webpack_public_path__ + "static/media/word.ea416314.jfif";